<template>
    <main class="main-content main-content-cinema main-content-cinema--nobg">
        <div class="container-fluid container-cinema">
            <div class="row">
                <div class="col-12">
                    <p class="cinema-title"><strong>Cinema</strong></p>
                </div>
            </div>
        </div>

        <div class="movie-details-section" :style="`background: url(${fundo}) no-repeat`" v-if="filme">
            <div class="container">
                <div class="row">

                    <div class="col-sm-12 col-md-8 align-row-center">
                        <div class="movie-details-intro">
                            <p>{{filme.titulo}}</p>
                            <a type="button" @click="trailer=true" class="btn btn-primary btn-large movie-details-intro__button">
                                <img :src="utils.image(filme.share, 256, 168)" alt="">
                            </a>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-4 align-row-center">
                        <div class="movie-cover">
                            <img :src="filme.poster" alt="">
                        </div>
                    </div>        

                </div>
            </div>
        </div>

        <div class="container container-cinema-content" v-if="filme">
            <div class="row">
                <div class="col-12 col-lg-8">
                    <p class="synopsis-title">Sinopse</p>
                    <p class="synopsis-text">{{filme.sinopse}}</p>
                    <div class="movie-infos">
                        <div class="row">
                            <div class="col-12 col-md-3">
                                <p class="movie-info-title">Gênero</p>
                                <p>{{filme.generos}}</p>
                            </div>
                            <div class="col-12 col-md-3">
                                <p class="movie-info-title">Direção</p>
                                <p>{{filme.diretor}}</p>
                            </div>
                            <div class="col-12 col-md-3">
                                <p class="movie-info-title">Duração</p>
                                <p>{{filme.duracao}}m</p>
                            </div>
                            <div class="col-12 col-md-3">
                                <p class="movie-info-title">Classificação</p>
                                <p>{{filme.classificacao}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-4 container-cinema-content--ad-banner">
                    <div id='div-gpt-ad-1603502104885-0'></div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-lg-8">
                    <p class="synopsis-title">Elenco Principal</p>
                </div>
            </div>

            <div class="row row-cast">
                <div class="col-6 col-lg-2" v-for="ator in atores" :key="ator.ator">
                    <p class="cast-name">{{ator.ator}}</p>
                    <p>{{ator.personagem}}</p>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-lg-8">
                    <p class="synopsis-title">Confira as salas e horários</p>
                </div>
            </div>
            
            <div class="row cinema-exhibition">
                <div class="col-12 col-lg-12">
                    <div class="movie-schedule">
                        <div class="movie-schedule__calendar nav nav-pills" id="pills-tab" role="tablist">
                            <a 
                            id="schedule-saturday" 
                            :class="{'movie-schedule__calendar--item':true, 'active': active_tab==key}" 
                            data-toggle="pill" 
                            role="tab" 
                            aria-controls="pills-saturday" 
                            aria-selected="true"
                            @click="active_tab=key"
                            v-for="(horario,key) in horarios" :key="key">
                                <span v-html="dateFormated(key)"></span>
                            </a>
                        </div>

                        <div class="tab-content movie-schedule__calendar-boxes" id="pills-tabContent" role="tablist">
                            <div 
                                :class="{'tab-pane fade show': true, 'active': active_tab==key}" 
                                id="pills-saturday" 
                                role="tabpanel" 
                                aria-labelledby="schedule-saturday"
                                v-for="(horario, key) in horarios" :key="key">
                                
                                <div class="row">
                                    <div class="col-sm-12 col-md-6 col-lg-6" v-for="(cinema, cinema_key) in horario" :key="cinema_key">
                                        <div class="movie-schedule__calendar-boxes--item">
                                            <h1 class="cinema-place">
                                                {{cinema.cinema}}
                                            </h1>
                        
                                            <div class="row cinema-hours">
                                                <div class="col-4 col-lg-4" v-for="hora in cinema.horarios" :key="hora.hora">
                                                    <div class="cinema-hours--item">
                                                        <div class="hour">{{hora.hora}}</div>
                                                        <div class="audio">{{hora.idioma}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="video-model active" v-if="trailer">
            <div class="model-close" @click="trailer=false">
                <em class="fa fa-close"></em>
            </div>
            <div class="model-iframe">
                <div class="video-container">
                    <!-- Pegar video id dinâmico e trocar por: XRTtGpedgY8 -->
                    <iframe 
                        v-if="youtube_id"
                        width="100%" 
                        height="700" 
                        :data-url="`https://www.youtube.com/embed/${youtube_id}?autoplay=1&rel=0&controls=0&showinfo=0`"
                        :src="`https://www.youtube.com/embed/${youtube_id}?autoplay=1&amp;rel=0&amp;controls=0&amp;showinfo=0`" 
                        frameborder="0" 
                        allowfullscreen="" 
                        class="movieEmbedList">
                    </iframe>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import movie from '@/store/movie'
import utils from '@/utils'

export default {
    name: 'Cinema',
    head:{
        title: function() {
            return{
                inner: this.title
            }
        }
    },
    data: function() {
        return {
            title: '',
            filme: null,
            fundo: null,
            atores: [],
            horarios: [],
            utils: utils,
            weekdays: ['Domingo','Segunda','Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
            active_tab: null,
            trailer: false,
            youtube_id: null
        }
    },
    methods: {
        async getFilme(){
            await movie.dispatch('getMovies')
            this.filme = movie.getters.get(this.$route.params.slug)
            if (this.filme === undefined) {
                this.$router.push('/404')
            } else {
                this.title = this.filme.titulo
                this.$emit('updateHead')
                this.fundo = utils.image(this.filme.fundo)
                this.atores = JSON.parse(this.filme.atores).slice(0,5)
                this.horarios = this.getHorarios()
                this.active_tab = Object.keys(this.horarios)[0]
                this.youtube_id = this.filme.trailer
            }
        },
        getHorarios() {
            let horarios = {}
            for (let index_cidade in this.filme.horarios.al.cidades) {
                let cidade = this.filme.horarios.al.cidades[index_cidade]

                for (let index_cinema in cidade.cinemas) {
                    let cinema = cidade.cinemas[index_cinema]

                    for (let index_data in cinema.datas) {
                        let data = cinema.datas[index_data]

                        let secao = {
                            data: new Date(data.data.replace(/-/g,'/')),
                            cinema: cinema.nome,
                            horarios: data.horarios
                        }

                        if ("undefined" === typeof(horarios[data.data])) {
                            horarios[data.data] = [secao]
                        } else {
                            horarios[data.data].push(secao)
                        }
                    }
                }
            }

            return horarios
        },
        dateFormated(date) {
            date = new Date(date.replace(/-/g,'/'))
            return `
                <p>${this.weekdays[date.getDay()]}</p>
                <p>${date.getDate()}</p>
                <p>${date.toLocaleDateString('pt-BR', {month:'long'})}</p>
            `
        }
    },
    mounted() {
        this.getFilme()

        var googletag = window.googletag
        googletag.cmd.push(function() {
            googletag.destroySlots()
            googletag.defineSlot('/1513505/v1_gweb_arroba_lateral', [300, 250], 'div-gpt-ad-1603502104885-0').addService(googletag.pubads());
            googletag.pubads().enableSingleRequest()
            googletag.pubads().collapseEmptyDivs()
            googletag.enableServices()
            googletag.display('div-gpt-ad-1603502104885-0')
        })
    }
}
</script>